/**
 * Dev-only logging helpers. In production builds these are no-ops, so we can keep
 * observability during development without leaking debug info to end users.
 */
const isDev = process.env.NODE_ENV !== "production";

export function devWarn(...args) {
  if (isDev) console.warn(...args);
}

export function devDebug(...args) {
  if (isDev) console.debug(...args);
}
